import React, { useCallback, useState, memo } from 'react';

import DatePicker from 'components/cosmos/date-picker';
import Dropdown from 'components/cosmos/dropdown';
import Loading from 'components/cosmos/loading';
import DateHelper from 'helpers/Date';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import PropTypes from 'prop-types';

import { SCHEDULER_OPTIONS, PREVIOUS, BEGIN } from './constants';
import SchedulerHeader from './SchedulerHeader';
import SchedulerService from './SchedulerService';

import {
  clickSaveDate,
  clickCancelDate,
  clickMonthDate,
  clickYearDate
} from '../DrippingBulkActionEvents';

import './DateSelector.scss';

const FIELD_NAME = 'date';

export const SCHEMA = { [FIELD_NAME]: 'required' };

// TODO não tá funcionando por problemas do componente do Cosmos
const sendClickSaveDateEvents = () => {
  clickSaveDate();

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      action: EVENTS_INTERACTIONS.CLICK,
      label: EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.BY_DATE_SAVE
    })
  });
};

// TODO não tá funcionando por problemas do componente do Cosmos
const sendClickCancelDateEvents = (e) => {
  e.stopPropagation();

  clickCancelDate();

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      action: EVENTS_INTERACTIONS.CLICK,
      label: EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.BY_DATE_CANCEL
    })
  });
};

// TODO não tá funcionando por problemas do componente do Cosmos
const sendClickMonthDateEvents = () => {
  clickMonthDate();

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      action: EVENTS_INTERACTIONS.CLICK,
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      label: `${EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.BY_DATE}${EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.SELECT_MONTH}`
    })
  });
};

// TODO não tá funcionando por problemas do componente do Cosmos
const sendClickYearDateEvents = () => {
  clickYearDate();

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      action: EVENTS_INTERACTIONS.CLICK,
      category: EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
      label: `${EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.BY_DATE}${EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.SELECT_YEAR}`
    })
  });
};

const DateSelector = ({
  type,
  checkedContent,
  transition,
  toogle,
  updateWizardState
}) => {
  const [sending, setSending] = useState(false);
  const { title, wizard } = SCHEDULER_OPTIONS[type] || {};

  const clickInput = (e) => {
    e.stopPropagation();
  };

  const goToPrevious = (e) => {
    e.stopPropagation();

    updateWizardState && updateWizardState(PREVIOUS);

    transition(PREVIOUS, { type });
  };

  const goToBegin = () => {
    updateWizardState && updateWizardState(BEGIN);

    transition(BEGIN, { type });
  };

  const closeDropdown = () => {
    toogle && toogle();

    Dropdown.closeMenu();

    goToBegin();
  };

  const setDripping = useCallback(
    async (dateResponse) => {
      try {
        setSending(true);

        const customDate = DateHelper.removeTimezone(
          dateResponse.selectedDates[0]
        );
        const timestamp = customDate.getTime();

        await SchedulerService.setDrippingByDate(timestamp, checkedContent);
      } finally {
        setSending(false);
      }
    },
    [checkedContent]
  );

  return (
    <>
      {sending && <Loading data-test="ca-days-selector-loading" />}
      <SchedulerHeader
        goToPrevious={goToPrevious}
        description={wizard}
        closeDropdown={closeDropdown}
        title={title}
      />
      <Dropdown.MenuItem className="date-selector__container _pb-4 _pt-4 _pl-5 _pr-5">
        <DatePicker
          placeholder="dripping.date.select_date"
          onChange={setDripping}
          clickInput={clickInput}
          clickCancelButton={sendClickCancelDateEvents}
          clickSaveButton={sendClickSaveDateEvents}
          clickMonthButton={sendClickMonthDateEvents}
          clickYearButton={sendClickYearDateEvents}
        />
      </Dropdown.MenuItem>
    </>
  );
};

DateSelector.propTypes = {
  type: PropTypes.string,
  checkedContent: PropTypes.object,
  transition: PropTypes.func,
  toogle: PropTypes.func,
  updateWizardState: PropTypes.func
};

export default memo(DateSelector);
